/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Timeline_Empty_TitleInputs */

const en_case_detail_timeline_empty_title = /** @type {(inputs: Case_Detail_Timeline_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No activity yet`)
};

const pt_br2_case_detail_timeline_empty_title = /** @type {(inputs: Case_Detail_Timeline_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma atividade ainda`)
};

/**
* | output |
* | --- |
* | "No activity yet" |
*
* @param {Case_Detail_Timeline_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_timeline_empty_title = /** @type {((inputs?: Case_Detail_Timeline_Empty_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Timeline_Empty_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_timeline_empty_title(inputs)
	return pt_br2_case_detail_timeline_empty_title(inputs)
});